export default {
  index(campaignId, params = {}, options = {}) {
    return Vue.http.get(
      `campaigns/${campaignId}/tags`,
      { params, ...options }
    ).then(response => response.data)
  },
  all(params = {}, options = {}) {
    return Vue.http.get(
      'campaigns/tags',
      { params, ...options }
    ).then(response => response.data)
  },
  tagsByCampaign(campaignId, params = {}, options = {}) {
    return Vue.http.get(
      `campaigns/${campaignId}/tags`,
      { params, skipLoading: true, ...options }
    ).then(response => response.data)
  },
  // Acá se usa el método GET para mostrar el listado por campañas
  getTagsByCampaign(campaignId, params = {}, options = {}) {
    params.campaignId = campaignId;
    return Vue.http.get(
      'tag',
      { params, ...options }
    ).then(response => response.data)
    
  },
  // Este método put se usa para acualizar los tags por medio de su ID
  updateTag(tagId, data, options = {}) {
    return Vue.http.put(
      `tag/${tagId}`,
      data,
      { ...options }
    ).then(response => response.data)
  }
}
